export const carouselRowProductsClippedComponent = {
  key: 'carouselRowProductsClippedComponent',
  name: 'Carousel Row Products Clipped Component',
  siteIdentifier: 'global',

  previousButtonAriaLabel: 'Previous',
  nextButtonAriaLabel: 'Next',
};
